import { createSelector } from 'reselect';

const selectAuth = state => state.authData;

const makeSelectProfile = () =>
  createSelector(selectAuth, authState => authState.profile);

export { selectAuth, makeSelectProfile };
